export const CONFIG_KEY = 'configs';
export const USER_KEY = 'user';
export const USER_ACCESS_TOKEN = 'access_token';
export const USER_LOGGED_IN_TIME = 'user_logged_time';

export enum TERM_AND_CONDITION_PAGE {
	FIRST_PAGE = 1,
	SECOND_PAGE = 2,
	THIRD_PAGE = 3
}

export enum ACCOUNT_TYPE {
	CORPORATE = 'corporate',
	INDIVIDUAL = 'individual'
}

export enum ACCOUNT_TYPE_CODE {
	CORPORATE = 2,
	INDIVIDUAL = 1
}

const _accountTypeMap = new Map<number, string>();
_accountTypeMap.set(ACCOUNT_TYPE_CODE.INDIVIDUAL, ACCOUNT_TYPE.INDIVIDUAL);
_accountTypeMap.set(ACCOUNT_TYPE_CODE.CORPORATE, ACCOUNT_TYPE.CORPORATE);

export const ACCOUNT_TYPE_MAP = _accountTypeMap;

export enum KYC_STATUS {
	NOT_VERIFIED = 1,
	VERIFIED = 2,
	DELETED = 3
}

export enum ONBOARDING_STATUS {
	WAITING_FOR_APPROVAL = 1,
	APPROVED = 2,
	REJECTED = 3
}

export enum GENDER {
	MALE = 'M',
	FEMALE = 'F',
	UNDEFINED = 'U'
}
export enum ADDRESS_TYPE {
	RESIDENTIAL = 1,
	MAILING = 2
}

export enum DASHBOARD_TYPES {
	FUNDER = 'funder',
	BORROWER = 'borrower',
	MORTGAGE = 'mortgage',
	DEAL = 'deal'
}

export enum OTP_MODE {
	LOGIN = 'login',
	REGISTER = 'register'
}

export enum ONBOARDING_E_FORM_PAGE {
	FIRST_PAGE = 1,
	SECOND_PAGE = 2,
	THIRD_PAGE = 3
}

export enum ONBOARDING_TYPE {
	FUNDER = 2,
	BORROWER = 4
}

export enum INDIVIDUAL_OTHER_DETAIL_QUESTIONS {
	_1ST = 'question1',
	_2ND = 'question2',
	_3RD = 'question3',
	_4TH = 'question4',
	_5TH = 'question5',
	_6TH = 'question6'
}

export enum TITLE {
	MS = 'ms',
	MISS = 'miss',
	MRS = 'mrs',
	MR = 'mr',
	OTHERS = 'others'
}

export enum GENDER_OTHERS {
	FEMALE = 'Female',
	MALE = 'Male',
	X = 'X'
}

export enum ONBOARDING_CURRENCY_TYPE {
	HKD = 'HKD',
	USD = 'USD',
	GBP = 'GBP',
	JPY = 'JPY',
	AUD = 'AUD',
	CAD = 'CAD'
}
const monthOptions = [];
for (let i = 1; i <= 12; i++) {
	monthOptions.push({
		key: i,
		value: i,
		label: i
	});
}
export const MONTH_OPTIONS = [12, 18, 24, 36, 48, 60].map((i) => {
	return {
		key: i,
		value: i,
		label: i
	};
});

export const PERCENTAGE_OPTIONS = [4, 5, 6, 7, 8, 9, 10].map((i) => {
	return {
		key: i,
		value: i,
		label: i
	};
});

export const INTEREST_PAYMENT_MONTH_OPTIONS = [3, 6].map((i) => {
	return {
		key: i,
		value: i,
		label: i
	};
});

export enum ONBOARDING_STATUSES {
	InCompleted = 0,
	Draft = 1,
	WaitingForApproval = 2,
	Approved = 3,
	Rejected = 4,
	SignedFSA = 5
}

export const EMPLOYER_TYPE_OPTIONS = 'Government,Listed Company,Non-listed Company,Self-employed,Retired,Others'
	.split(',')
	.map((i) => {
		const rawVal = i.replace(' ', '');
		return {
			id: i.replace(' ', ''),
			key: rawVal.toLocaleLowerCase(),
			value: rawVal.toLocaleLowerCase(),
			label: i
		};
	});

export const OCCUPATION_LISTS =
	'Professional/Broker (Insurance & Realtor)/IT/Engineering/Technician/Entertainer&Actor&Actress/Clerical Support Worker/Service and Sales worker/Manager/Retired/Others'
		.split('/')
		.map((i) => {
			return {
				id: i,
				key: i,
				value: i.toLocaleLowerCase(),
				label: i
			};
		});

export const NATURE_OF_BUSINESSES =
	'Renting of land transport equipment,Renting of water transport equipment,Renting of air transport equipment,Renting of agricultural machinery and equipment,Renting of construction and civil engineering machinery,Renting of office machinery and equipment'
		.split(',')
		.map((i) => {
			return {
				id: i,
				key: i,
				value: i.toLocaleLowerCase(),
				label: i
			};
		});

export const DEFAULT_INPUT_MAX_NUMBER = 9999999999;
export const DEFAULT_ALLOWED_FILES = ['.xls', '.xlsx', '.doc', '.txt', '.vsdx', '.pdf'];
export const DEFAULT_ALLOWED_CHANGE_REQUEST_FILES = ['.xls', '.xlsx', '.doc', '.docx', '.txt', '.vsdx', '.pdf', '.jpg', '.jpeg'];
export const DEFAULT_ALLOWED_IMAGE_FILES = ['.png', '.jpg', '.jpeg', '.heic'];
export const DEFAULT_ALLOWED_OTHER_FILES = ['.xls', '.xlsx', '.doc', '.txt', '.vsdx', '.pdf'];

export const DEFAULT_ALLOWED_FILES_DOCUMENT = {
	identities: ['.bmp', '.pdf', '.jpg', '.jpeg', '.gif', '.tif'],
	selfie: ['.png', '.jpg', '.jpeg', '.heic'],
	residentialProof: ['.pdf', '.png', '.jpg', '.jpeg'],
	commonFile: ['.xls', '.xlsx', '.doc', '.docx', '.txt', '.vsdx', '.pdf', '.jpg']
};

export const FILE_SIZE_ALLOWED = {
	SINGLE: 5 * 1024 * 1024,
	TOTAL: 100 * 1024 * 1024,
	MINIMUM_SIZE_FILE: 50 * 1024
};

export const CURRENCY_OPTIONS = [
	{
		key: ONBOARDING_CURRENCY_TYPE.HKD,
		value: ONBOARDING_CURRENCY_TYPE.HKD,
		label: ONBOARDING_CURRENCY_TYPE.HKD
	},
	{
		key: ONBOARDING_CURRENCY_TYPE.USD,
		value: ONBOARDING_CURRENCY_TYPE.USD,
		label: ONBOARDING_CURRENCY_TYPE.USD
	},
	{
		key: ONBOARDING_CURRENCY_TYPE.GBP,
		value: ONBOARDING_CURRENCY_TYPE.GBP,
		label: ONBOARDING_CURRENCY_TYPE.GBP
	},
	{
		key: ONBOARDING_CURRENCY_TYPE.JPY,
		value: ONBOARDING_CURRENCY_TYPE.JPY,
		label: ONBOARDING_CURRENCY_TYPE.JPY
	},
	{
		key: ONBOARDING_CURRENCY_TYPE.AUD,
		value: ONBOARDING_CURRENCY_TYPE.AUD,
		label: ONBOARDING_CURRENCY_TYPE.AUD
	},
	{
		key: ONBOARDING_CURRENCY_TYPE.CAD,
		value: ONBOARDING_CURRENCY_TYPE.CAD,
		label: ONBOARDING_CURRENCY_TYPE.CAD
	}
];

export enum COMPANY_ONBOARDING_TYPE {
	FUNDER = 1,
	BORROWER = 2
}
const obTypeMapper = new Map<ONBOARDING_TYPE, number>();
obTypeMapper.set(ONBOARDING_TYPE.FUNDER, 1);
obTypeMapper.set(ONBOARDING_TYPE.BORROWER, 2);
export const FILE_ONBOARDING_TYPE_MAPPER = obTypeMapper;

export const EMPLOYMENT_TYPE_CODE = {
	employed: '1',
	selfEmployed: '2',
	retired: '3',
	others: '4'
};

export const PAGINATION_CONFIGURATION = {
	DEFAULT_PAGE: 1,
	DEFAULT_PAGE_SIZE: 10
};
export enum SOLICITOR_NOMINEE {
	MKA = 1,
	LWC = 2
}

export enum SOLICITOR_NOMINEE_CODE {
	MKA = 'MKA',
	LWC = 'LWC'
}

export const INDI_MAINTANCE_FEE = {
	MKA: '1,950.00',
	LWC: '1,800.00'
};

export const COR_MAINTANCE_FEE = {
	MKA: '3,120.00',
	LWC: '3,000.00'
};

export interface IMonthsOption {
	key: number;
	value: number;
	label: number;
}

export const DEAFULT_COUNTRY_CODE_CHINESE = '86';

export const NATIONALITY_OPTIONS = [
	{ id: 'AX', label: 'Aaland Islands', key: 'AX', value: 'AX' },
	{ id: 'AF', label: 'Afghan', key: 'AF', value: 'AF' },
	{ id: 'AL', label: 'Albanian', key: 'AL', value: 'AL' },
	{ id: 'DZ', label: 'Algerian', key: 'DZ', value: 'DZ' },
	{ id: 'AS', label: 'American Samoan', key: 'AS', value: 'AS' },
	{ id: 'AD', label: 'Andorran', key: 'AD', value: 'AD' },
	{ id: 'AO', label: 'Angolan', key: 'AO', value: 'AO' },
	{ id: 'AI', label: 'Anguillan', key: 'AI', value: 'AI' },
	{ id: 'AQ', label: 'Antarctican', key: 'AQ', value: 'AQ' },
	{ id: 'AG', label: 'Antigua and Babu', key: 'AG', value: 'AG' },
	{ id: 'AR', label: 'Argentinian', key: 'AR', value: 'AR' },
	{ id: 'AM', label: 'Armenian', key: 'AM', value: 'AM' },
	{ id: 'AW', label: 'Aruban', key: 'AW', value: 'AW' },
	{ id: 'AU', label: 'Australian', key: 'AU', value: 'AU' },
	{ id: 'AT', label: 'Austrian', key: 'AT', value: 'AT' },
	{ id: 'AZ', label: 'Azerbaijani', key: 'AZ', value: 'AZ' },
	{ id: 'BS', label: 'Bahamian', key: 'BS', value: 'BS' },
	{ id: 'BH', label: 'Bahraini', key: 'BH', value: 'BH' },
	{ id: 'BD', label: 'Bangladeshi', key: 'BD', value: 'BD' },
	{ id: 'BB', label: 'Barbadian', key: 'BB', value: 'BB' },
	{ id: 'BY', label: 'Belarusian', key: 'BY', value: 'BY' },
	{ id: 'BE', label: 'Belgian', key: 'BE', value: 'BE' },
	{ id: 'BZ', label: 'Belizean', key: 'BZ', value: 'BZ' },
	{ id: 'BJ', label: 'Beninese', key: 'BJ', value: 'BJ' },
	{ id: 'BM', label: 'Bermudan', key: 'BM', value: 'BM' },
	{ id: 'BT', label: 'Bhutanese', key: 'BT', value: 'BT' },
	{ id: 'BO', label: 'Bolivian', key: 'BO', value: 'BO' },
	{
		id: 'BQ',
		label: 'Bonaire, Sint Eustatius and Saba',
		key: 'BQ',
		value: 'BQ'
	},
	{ id: 'BA', label: 'Bosnian', key: 'BA', value: 'BA' },
	{ id: 'BW', label: 'Botswanan', key: 'BW', value: 'BW' },
	{ id: 'BV', label: 'Bouvet Island', key: 'BV', value: 'BV' },
	{ id: 'BR', label: 'Brazilian', key: 'BR', value: 'BR' },
	{
		id: 'IO',
		label: 'British Indian Ocean Territory',
		key: 'IO',
		value: 'IO'
	},
	{ id: 'BN', label: 'Bruneian', key: 'BN', value: 'BN' },
	{ id: 'BG', label: 'Bulgarian', key: 'BG', value: 'BG' },
	{ id: 'BF', label: 'Burkinese', key: 'BF', value: 'BF' },
	{ id: 'BI', label: 'Burundian', key: 'BI', value: 'BI' },
	{ id: 'KH', label: 'Cambodian', key: 'KH', value: 'KH' },
	{ id: 'CM', label: 'Cameroonian', key: 'CM', value: 'CM' },
	{ id: 'CA', label: 'Canadian', key: 'CA', value: 'CA' },
	{ id: 'CV', label: 'Cape Verdean', key: 'CV', value: 'CV' },
	{ id: 'KY', label: 'Caymanian', key: 'KY', value: 'KY' },
	{
		id: 'CF',
		label: 'Central African',
		key: 'CF',
		value: 'CF'
	},
	{ id: 'TD', label: 'Chadian', key: 'TD', value: 'TD' },
	{ id: 'CL', label: 'Chilean', key: 'CL', value: 'CL' },
	{ id: 'CN', label: 'Chinese', key: 'CN', value: 'CN' },
	{ id: 'CX', label: 'Christmas Islander', key: 'CX', value: 'CX' },
	{
		id: 'CC',
		label: 'Cocossian',
		key: 'CC',
		value: 'CC'
	},
	{ id: 'CO', label: 'Colombian', key: 'CO', value: 'CO' },
	{ id: 'KM', label: 'Comorian', key: 'KM', value: 'KM' },
	{ id: 'CG', label: 'Congolese - Brazzaville', key: 'CG', value: 'CG' },
	{
		id: 'CD',
		label: 'Congolese - Kinshasa',
		key: 'CD',
		value: 'CD'
	},
	{ id: 'CK', label: 'Cook Islander', key: 'CK', value: 'CK' },
	{ id: 'CR', label: 'Costa Rican', key: 'CR', value: 'CR' },
	{ id: 'CI', label: 'Ivorian', key: 'CI', value: 'CI' },
	{ id: 'HR', label: 'Croatian', key: 'HR', value: 'HR' },
	{ id: 'CU', label: 'Cuban', key: 'CU', value: 'CU' },
	{ id: 'CW', label: 'Curacaoan', key: 'CW', value: 'CW' },
	{ id: 'CY', label: 'Cypriot', key: 'CY', value: 'CY' },
	{ id: 'CZ', label: 'Czech', key: 'CZ', value: 'CZ' },
	{ id: 'DK', label: 'Denmark', key: 'DK', value: 'DK' },
	{ id: 'DJ', label: 'Djiboutian', key: 'DJ', value: 'DJ' },
	{ id: 'DM', label: 'Dominican', key: 'DM', value: 'DM' },
	{ id: 'DO', label: 'Dominican - Republic', key: 'DO', value: 'DO' },
	{ id: 'EC', label: 'Ecuadorean', key: 'EC', value: 'EC' },
	{ id: 'EG', label: 'Egyptian', key: 'EG', value: 'EG' },
	{ id: 'SV', label: 'Salvadorean', key: 'SV', value: 'SV' },
	{ id: 'GQ', label: 'Guinean', key: 'GQ', value: 'GQ' },
	{ id: 'ER', label: 'Eritrean', key: 'ER', value: 'ER' },
	{ id: 'EE', label: 'Estonian', key: 'EE', value: 'EE' },
	{
		id: 'SZ',
		label: 'SwaziSwazi',
		key: 'SZ',
		value: 'SZ'
	},
	{ id: 'ET', label: 'Ethiopian', key: 'ET', value: 'ET' },
	{
		id: 'FK',
		label: 'Falkland Islander',
		key: 'FK',
		value: 'FK'
	},
	{ id: 'FO', label: 'Faroe Islander', key: 'FO', value: 'FO' },
	{ id: 'FJ', label: 'Fijian', key: 'FJ', value: 'FJ' },
	{ id: 'FI', label: 'Finnish', key: 'FI', value: 'FI' },
	{ id: 'FR', label: 'French', key: 'FR', value: 'FR' },
	{ id: 'GF', label: 'Guianan', key: 'GF', value: 'GF' },
	{ id: 'PF', label: 'French Polynesian', key: 'PF', value: 'PF' },
	{
		id: 'TF',
		label: 'French Southern Territories',
		key: 'TF',
		value: 'TF'
	},
	{ id: 'GA', label: 'Gabonese', key: 'GA', value: 'GA' },
	{ id: 'GM', label: 'Gambian', key: 'GM', value: 'GM' },
	{ id: 'GE', label: 'Georgian', key: 'GE', value: 'GE' },
	{ id: 'DE', label: 'German', key: 'DE', value: 'DE' },
	{ id: 'GH', label: 'Ghanaian', key: 'GH', value: 'GH' },
	{ id: 'GI', label: 'Gibraltarian', key: 'GI', value: 'GI' },
	{ id: 'GR', label: 'Greek', key: 'GR', value: 'GR' },
	{ id: 'GL', label: 'Greenlandic', key: 'GL', value: 'GL' },
	{ id: 'GD', label: 'Grenadian', key: 'GD', value: 'GD' },
	{ id: 'GP', label: 'Guadeloupean', key: 'GP', value: 'GP' },
	{ id: 'GU', label: 'Guamanian', key: 'GU', value: 'GU' },
	{ id: 'GT', label: 'Guatemalan', key: 'GT', value: 'GT' },
	{ id: 'GG', label: 'Guern', key: 'GG', value: 'GG' },
	{ id: 'GN', label: 'Guinea', key: 'GN', value: 'GN' },
	{ id: 'GW', label: 'Guinean - Bissau', key: 'GW', value: 'GW' },
	{ id: 'GY', label: 'Guyanese', key: 'GY', value: 'GY' },
	{ id: 'HT', label: 'Haitian', key: 'HT', value: 'HT' },
	{
		id: 'HM',
		label: 'Heard and McDonald Islands',
		key: 'HM',
		value: 'HM'
	},
	{
		id: 'VA',
		label: 'Holy See (Vatican City State)',
		key: 'VA',
		value: 'VA'
	},
	{ id: 'HN', label: 'Honduran', key: 'HN', value: 'HN' },
	{ id: 'HK', label: 'HongKonger', key: 'HK', value: 'HK' },
	{ id: 'HU', label: 'Hungarian', key: 'HU', value: 'HU' },
	{ id: 'IS', label: 'Icelandic', key: 'IS', value: 'IS' },
	{ id: 'IN', label: 'Indian', key: 'IN', value: 'IN' },
	{ id: 'ID', label: 'Indonesian', key: 'ID', value: 'ID' },
	{
		id: 'IR',
		label: 'Iranian',
		key: 'IR',
		value: 'IR'
	},
	{ id: 'IQ', label: 'Iraqi', key: 'IQ', value: 'IQ' },
	{ id: 'IE', label: 'Ireland', key: 'IE', value: 'IE' },
	{ id: 'IM', label: 'Manx', key: 'IM', value: 'IM' },
	{ id: 'IL', label: 'Israelite', key: 'IL', value: 'IL' },
	{ id: 'IT', label: 'Italian', key: 'IT', value: 'IT' },
	{ id: 'JM', label: 'Jamaican', key: 'JM', value: 'JM' },
	{ id: 'JP', label: 'Japanese', key: 'JP', value: 'JP' },
	{ id: 'JE', label: 'Jersey', key: 'JE', value: 'JE' },
	{ id: 'JO', label: 'Jordanian', key: 'JO', value: 'JO' },
	{ id: 'KZ', label: 'Kazakh', key: 'KZ', value: 'KZ' },
	{ id: 'KE', label: 'Kenyan', key: 'KE', value: 'KE' },
	{ id: 'KI', label: 'I-Kiribati', key: 'KI', value: 'KI' },
	{
		id: 'KP',
		label: 'North Korean',
		key: 'KP',
		value: 'KP'
	},
	{ id: 'KR', label: 'South Korean', key: 'KR', value: 'KR' },
	{ id: 'XK', label: 'Kosovan', key: 'XK', value: 'XK' },
	{ id: 'KW', label: 'Kuwaiti', key: 'KW', value: 'KW' },
	{ id: 'KG', label: 'Kyrgyz', key: 'KG', value: 'KG' },
	{
		id: 'MY-15',
		label: 'Labuan - Malaysian federal territory',
		key: 'MY-15',
		value: 'MY-15'
	},
	{
		id: 'LA',
		label: 'Laotian',
		key: 'LA',
		value: 'LA'
	},
	{ id: 'LV', label: 'Latvian', key: 'LV', value: 'LV' },
	{ id: 'LB', label: 'Lebanese', key: 'LB', value: 'LB' },
	{ id: 'LS', label: 'Mosotho', key: 'LS', value: 'LS' },
	{ id: 'LR', label: 'Liberian', key: 'LR', value: 'LR' },
	{ id: 'LY', label: 'Libyan', key: 'LY', value: 'LY' },
	{ id: 'LI', label: 'Liechtensteiner', key: 'LI', value: 'LI' },
	{ id: 'LT', label: 'Lithuanian', key: 'LT', value: 'LT' },
	{ id: 'LU', label: 'Luxembourger', key: 'LU', value: 'LU' },
	{ id: 'MO', label: 'Macanese', key: 'MO', value: 'MO' },
	{
		id: 'MK',
		label: 'Macedonian',
		key: 'MK',
		value: 'MK'
	},
	{ id: 'MG', label: 'Madagascan', key: 'MG', value: 'MG' },
	{ id: 'MW', label: 'Malawian', key: 'MW', value: 'MW' },
	{ id: 'MY', label: 'Malaysian', key: 'MY', value: 'MY' },
	{ id: 'MV', label: 'Maldivian', key: 'MV', value: 'MV' },
	{ id: 'ML', label: 'Malian', key: 'ML', value: 'ML' },
	{ id: 'MT', label: 'Maltese', key: 'MT', value: 'MT' },
	{ id: 'MH', label: 'Marshallese', key: 'MH', value: 'MH' },
	{ id: 'MQ', label: 'Martinicquan', key: 'MQ', value: 'MQ' },
	{ id: 'MR', label: 'Mauritanian', key: 'MR', value: 'MR' },
	{ id: 'MU', label: 'Mauritian', key: 'MU', value: 'MU' },
	{ id: 'YT', label: 'Mahoran', key: 'YT', value: 'YT' },
	{ id: 'MX', label: 'Mexican', key: 'MX', value: 'MX' },
	{
		id: 'FM',
		label: 'Micronesian',
		key: 'FM',
		value: 'FM'
	},
	{ id: 'MD', label: 'Moldovan', key: 'MD', value: 'MD' },
	{ id: 'MC', label: 'Monacan', key: 'MC', value: 'MC' },
	{ id: 'MN', label: 'Mongolian', key: 'MN', value: 'MN' },
	{ id: 'ME', label: 'Montenegrin', key: 'ME', value: 'ME' },
	{ id: 'MS', label: 'Monsterratian', key: 'MS', value: 'MS' },
	{ id: 'MA', label: 'Moroccan', key: 'MA', value: 'MA' },
	{ id: 'MZ', label: 'Mozambican', key: 'MZ', value: 'MZ' },
	{ id: 'MM', label: 'Myanmar', key: 'MM', value: 'MM' },
	{ id: 'NA', label: 'Namibian', key: 'NA', value: 'NA' },
	{ id: 'NR', label: 'Nauruan', key: 'NR', value: 'NR' },
	{ id: 'NP', label: 'Nepalese', key: 'NP', value: 'NP' },
	{ id: 'NL', label: 'Dutch', key: 'NL', value: 'NL' },
	{ id: 'AN', label: 'Netherlands Antillean', key: 'AN', value: 'AN' },
	{ id: 'NC', label: 'New Caledonian', key: 'NC', value: 'NC' },
	{ id: 'NZ', label: 'New Zealander', key: 'NZ', value: 'NZ' },
	{ id: 'NI', label: 'Nicaraguan', key: 'NI', value: 'NI' },
	{ id: 'NE', label: 'Nigerien', key: 'NE', value: 'NE' },
	{ id: 'NG', label: 'Nigerian', key: 'NG', value: 'NG' },
	{ id: 'NU', label: 'Niuean', key: 'NU', value: 'NU' },
	{ id: 'NF', label: 'Norfolk Islander', key: 'NF', value: 'NF' },
	{
		id: 'MP',
		label: 'Northern Mariana Islander',
		key: 'MP',
		value: 'MP'
	},
	{ id: 'NO', label: 'Norwegian', key: 'NO', value: 'NO' },
	{ id: 'OM', label: 'Omani', key: 'OM', value: 'OM' },
	{ id: 'PK', label: 'Pakistani', key: 'PK', value: 'PK' },
	{ id: 'PW', label: 'Palauan', key: 'PW', value: 'PW' },
	{ id: 'PS', label: 'Palestinian', key: 'PS', value: 'PS' },
	{ id: 'PA', label: 'Panama', key: 'PA', value: 'PA' },
	{ id: 'PG', label: 'Papua New Guinean', key: 'PG', value: 'PG' },
	{ id: 'PY', label: 'Paraguayan', key: 'PY', value: 'PY' },
	{ id: 'PE', label: 'Peruvian', key: 'PE', value: 'PE' },
	{ id: 'PH', label: 'Philippine', key: 'PH', value: 'PH' },
	{ id: 'PN', label: 'Pitcairn Islander', key: 'PN', value: 'PN' },
	{ id: 'PL', label: 'Polish', key: 'PL', value: 'PL' },
	{ id: 'PT', label: 'Portuguese', key: 'PT', value: 'PT' },
	{ id: 'PR', label: 'Puerto Rican', key: 'PR', value: 'PR' },
	{ id: 'QA', label: 'Qatari', key: 'QA', value: 'QA' },
	{ id: 'RE', label: 'Reunionese', key: 'RE', value: 'RE' },
	{ id: 'RO', label: 'Romanian', key: 'RO', value: 'RO' },
	{ id: 'RU', label: 'Russian', key: 'RU', value: 'RU' },
	{ id: 'RW', label: 'Rwandan', key: 'RW', value: 'RW' },
	{ id: 'BL', label: 'Saint Barthélemy', key: 'BL', value: 'BL' },
	{ id: 'SH', label: 'Saint Helenian', key: 'SH', value: 'SH' },
	{
		id: 'PM',
		label: 'Saint Helena, Ascension and Tristan da Cunha',
		key: 'PM',
		value: 'PM'
	},
	{ id: 'KN', label: 'Nevisian', key: 'KN', value: 'KN' },
	{ id: 'LC', label: 'Saint Lucian', key: 'LC', value: 'LC' },
	{
		id: 'MF',
		label: 'Saint Martin (French part)',
		key: 'MF',
		value: 'MF'
	},
	{
		id: 'VC',
		label: 'Vincentian',
		key: 'VC',
		value: 'VC'
	},
	{ id: 'WS', label: 'Samoan', key: 'WS', value: 'WS' },
	{ id: 'SM', label: 'Sammarinese', key: 'SM', value: 'SM' },
	{ id: 'ST', label: 'Sao Tomean', key: 'ST', value: 'ST' },
	{ id: 'SA', label: 'Saudi Arabian', key: 'SA', value: 'SA' },
	{ id: 'SN', label: 'Senegalese', key: 'SN', value: 'SN' },
	{ id: 'RS', label: 'Serbian', key: 'RS', value: 'RS' },
	{ id: 'SC', label: 'Seychellois', key: 'SC', value: 'SC' },
	{ id: 'SL', label: 'Sierra Leonian', key: 'SL', value: 'SL' },
	{ id: 'SG', label: 'Singaporean', key: 'SG', value: 'SG' },
	{
		id: 'SX',
		label: 'Sint Maarten (Dutch part)',
		key: 'SX',
		value: 'SX'
	},
	{ id: 'SK', label: 'Slovak', key: 'SK', value: 'SK' },
	{ id: 'SI', label: 'Slovenian', key: 'SI', value: 'SI' },
	{ id: 'SB', label: 'Solomon Islander', key: 'SB', value: 'SB' },
	{ id: 'SO', label: 'Somali', key: 'SO', value: 'SO' },
	{ id: 'ZA', label: 'South African', key: 'ZA', value: 'ZA' },
	{
		id: 'GS',
		label: 'South Georgian and the South Sandwich Islander',
		key: 'GS',
		value: 'GS'
	},
	{ id: 'SS', label: 'South Sudanese', key: 'SS', value: 'SS' },
	{ id: 'ES', label: 'Spanish', key: 'ES', value: 'ES' },
	{ id: 'LK', label: 'Sri Lankan', key: 'LK', value: 'LK' },
	{ id: 'SD', label: 'Sudanese', key: 'SD', value: 'SD' },
	{ id: 'SR', label: 'Surinamese', key: 'SR', value: 'SR' },
	{
		id: 'SJ',
		label: 'Svalbard and Jan Mayen Islands',
		key: 'SJ',
		value: 'SJ'
	},
	{ id: 'SE', label: 'Swedish', key: 'SE', value: 'SE' },
	{ id: 'CH', label: 'Swiss', key: 'CH', value: 'CH' },
	{ id: 'SY', label: 'Syrian', key: 'SY', value: 'SY' },
	{
		id: 'TW',
		label: 'Taiwanese',
		key: 'TW',
		value: 'TW'
	},
	{ id: 'TJ', label: 'Tajik', key: 'TJ', value: 'TJ' },
	{
		id: 'TZ',
		label: 'Tanzanian',
		key: 'TZ',
		value: 'TZ'
	},
	{ id: 'TH', label: 'Thai', key: 'TH', value: 'TH' },
	{ id: 'TL', label: 'Timorese', key: 'TL', value: 'TL' },
	{ id: 'TG', label: 'Togolese', key: 'TG', value: 'TG' },
	{ id: 'TK', label: 'Tokelauan', key: 'TK', value: 'TK' },
	{ id: 'TO', label: 'Tongan', key: 'TO', value: 'TO' },
	{ id: 'TT', label: 'Trinidadian', key: 'TT', value: 'TT' },
	{ id: 'TN', label: 'Tunisian', key: 'TN', value: 'TN' },
	{ id: 'TR', label: 'Turkish', key: 'TR', value: 'TR' },
	{ id: 'TM', label: 'Turkmen', key: 'TM', value: 'TM' },
	{
		id: 'TC',
		label: 'Turks and Caicos Islander',
		key: 'TC',
		value: 'TC'
	},
	{ id: 'TV', label: 'Tuvaluan', key: 'TV', value: 'TV' },
	{ id: 'UG', label: 'Ugandan', key: 'UG', value: 'UG' },
	{ id: 'UA', label: 'Ukrainian', key: 'UA', value: 'UA' },
	{ id: 'AE', label: 'Emirates', key: 'AE', value: 'AE' },
	{ id: 'GB', label: 'British', key: 'GB', value: 'GB' },
	{
		id: 'UM',
		label: 'United States Minor Outlying Islands',
		key: 'UM',
		value: 'UM'
	},
	{
		id: 'US',
		label: 'American',
		key: 'US',
		value: 'US'
	},
	{ id: 'NONE', label: 'Unknown', key: 'NONE', value: 'NONE' },
	{ id: 'UY', label: 'Uruguayan', key: 'UY', value: 'UY' },
	{ id: 'UZ', label: 'Uzbek', key: 'UZ', value: 'UZ' },
	{ id: 'VU', label: 'Vanuatuan', key: 'VU', value: 'VU' },
	{
		id: 'VE',
		label: 'Venezuelan',
		key: 'VE',
		value: 'VE'
	},
	{ id: 'VN', label: 'Vietnamese', key: 'VN', value: 'VN' },
	{
		id: 'VG',
		label: 'British Virgin Islander',
		key: 'VG',
		value: 'VG'
	},
	{ id: 'VI', label: 'American Virgin Islander', key: 'VI', value: 'VI' },
	{
		id: 'WF',
		label: 'Wallisian Futunan',
		key: 'WF',
		value: 'WF'
	},
	{ id: 'EH', label: 'Sahrawi', key: 'EH', value: 'EH' },
	{ id: 'YE', label: 'Yemeni', key: 'YE', value: 'YE' },
	{ id: 'ZM', label: 'Zambian', key: 'ZM', value: 'ZM' },
	{ id: 'ZW', label: 'Zimbabwean', key: 'ZW', value: 'ZW' },
	{ id: 'GBN', label: 'British national (overseas)', key: 'GBN', value: 'GBN' },
	{ id: 'GBO', label: 'British overseas citizen', key: 'GBO', value: 'GBO' },
	{ id: 'GBD', label: 'British overseas territories citizen', key: 'GBD', value: 'GBD' },
	{ id: 'GBP', label: 'British protected person', key: 'GBP', value: 'GBP' },
	{ id: 'GBS', label: 'British subject', key: 'GBS', value: 'GBS' },
	{ id: 'XXB', label: 'Refugee', key: 'XXB', value: 'XXB' },
	{ id: 'XXC', label: 'Refugee, Other', key: 'XXC', value: 'XXC' },
	{ id: 'UNK', label: 'Resident of Kosovo (issued by United Nations)', key: 'UNK', value: 'UNK' },
	{ id: 'XOM', label: 'Sovereign Military Order of Malta', key: 'XOM', value: 'XOM' },
	{ id: 'XXA', label: 'Stateless Person', key: 'XXA', value: 'XXA' },
	{ id: 'UNA', label: 'United Nations Agency', key: 'UNA', value: 'UNA' },
	{ id: 'UNO', label: 'United Nations Organization', key: 'UNO', value: 'UNO' },
];

export const LIST_OF_COUNTRY = `AF            Afghanistan
AX            Aland Islands
AL            Albania
DZ            Algeria
AS            American Samoa
AD            Andorra
AO            Angola
AI            Anguilla
AQ            Antarctica
AG            Antigua and Barbuda
AR            Argentina
AM            Armenia
AW            Aruba
AU            Australia
AT            Austria
AZ            Azerbaijan
BS            Bahamas
BH            Bahrain
BD            Bangladesh
BB            Barbados
BY            Belarus
BE            Belgium
BZ            Belize
BJ            Benin
BM            Bermuda
BT            Bhutan
BO            Bolivia
BQ            Bonaire, Sint Eustatius and Saba
BA            Bosnia and Herzegovina
BW            Botswana
BV            Bouvet Island
BR            Brazil
IO            British Indian Ocean Territory
BN            Brunei Darussalam
BG            Bulgaria
BF            Burkina Faso
BI            Burundi
KH            Cambodia
CM            Cameroon
CA            Canada
CV            Cape Verde
KY            Cayman Islands
CF            Central African Republic
TD            Chad
CL            Chile
CN            China
CX            Christmas Island
CC            Cocos (Keeling) Islands
CO            Colombia
KM            Comoros
CG            Congo
CD            Congo, The Democratic Republic of
CK            Cook Islands
CR            Costa Rica
CI            Cote d'Ivoire
HR            Croatia
CU            Cuba
CW            Curaçao
CY            Cyprus
CZ            Czechia
DK            Denmark
DJ            Djibouti
DM            Dominica
DO            Dominican Republic
EC            Ecuador
EG            Egypt
SV            El Salvador
GQ            Equatorial Guinea
ER            Eritrea
EE            Estonia
ET            Ethiopia
FK            Falkland Islands (Malvinas)
FO            Faroe Islands
FJ            Fiji
FI            Finland
FR            France
GF   French Guiana
PF   French Polynesia
TF   French Southern Territories
GA   Gabon
GM   Gambia
GE   Georgia
DE   Germany
GH   Ghana
GI   Gibraltar
GR   Greece
GL   Greenland
GD   Grenada
GP   Guadeloupe
GU   Guam
GT   Guatemala
GG   Guernsey
GN   Guinea
GW   Guinea-Bissau
GY   Guyana
HT   Haiti
HM   Heard and Mc Donald Islands
VA   Holy See (Vatican City State)
HN   Honduras
HK   Hong Kong, China
HU   Hungary
IS   Iceland
IN   India
ID   Indonesia
IR   Iran, Islamic Republic of
IQ   Iraq
IE   Ireland
IM   Isle of Man
IL   Israel
IT   Italy
JM   Jamaica
JP   Japan
JE   Jersey
JO   Jordan
KZ   Kazakstan
KE   Kenya
KI   Kiribati
KP   Korea, Democratic People's Republic of
KR   Korea, Republic of
XK   Kosovo (temporary code)
KW   Kuwait
KG   Kyrgyzstan
LA   Lao, People's Democratic Republic
LV   Latvia
LB   Lebanon
LS   Lesotho
LR   Liberia
LY   Libyan Arab Jamahiriya
LI   Liechtenstein
LT   Lithuania
LU   Luxembourg
MO   Macao
MK   Macedonia, The Former Yugoslav Republic Of
MG   Madagascar
MW   Malawi
MY   Malaysia
MV   Maldives
ML   Mali
MT   Malta
MH   Marshall Islands
MQ   Martinique
MR   Mauritania
MU   Mauritius
YT   Mayotte
MX   Mexico
FM   Micronesia, Federated States of
MD   Moldova, Republic of
MC   Monaco
MN   Mongolia
ME   Montenegro
MS   Montserrat
MA   Morocco
MZ   Mozambique
MM   Myanmar
NA   Namibia
NR   Nauru
NP   Nepal
NL   Netherlands
AN   Netherlands Antilles
NC   New Caledonia
NZ   New Zealand
NI   Nicaragua
NE   Niger
NG   Nigeria
NU   Niue
NF   Norfolk Island
MP   Northern Mariana Islands
NO   Norway
OM   Oman
PK   Pakistan
PW   Palau
PS   Palestinian Territory, Occupied
PA   Panama
PG   Papua New Guinea
PY   Paraguay
PE   Peru
PH   Philippines
PN   Pitcairn
PL   Poland
PT   Portugal
PR   Puerto Rico
QA   Qatar
RS   Republic of Serbia
RE   Reunion
RO   Romania
RU   Russia Federation
RW   Rwanda
BL   Saint Barthélemy
SH   Saint Helena
KN   Saint Kitts & Nevis
LC   Saint Lucia
MF   Saint Martin
PM   Saint Pierre and Miquelon
VC   Saint Vincent and the Grenadines
WS   Samoa
SM   San Marino
ST   Sao Tome and Principe
SA   Saudi Arabia
SN   Senegal
CS   Serbia and Montenegro
SC   Seychelles
SL   Sierra Leone
SG   Singapore
SX   Sint Maarten
SK   Slovakia
SI   Slovenia
SB   Solomon Islands
SO   Somalia
ZA   South Africa
GS   South Georgia & The South Sandwich Islands
SS   South Sudan
ES   Spain
LK   Sri Lanka
SD   Sudan
SR   Suriname
SJ   Svalbard and Jan Mayen
SZ   Swaziland
SE   Sweden
CH   Switzerland
SY   Syrian Arab Republic
TW   Taiwan, Province of China
TJ   Tajikistan
TZ   Tanzania, United Republic of
TH   Thailand
TL   Timor-Leste
TG   Togo
TK   Tokelau
TO   Tonga
TT   Trinidad and Tobago
TN   Tunisia
TR   Turkey
XT   Turkish Rep N Cyprus (temporary code)
TM   Turkmenistan
TC   Turks and Caicos Islands
TV   Tuvalu
UG   Uganda
UA   Ukraine
AE   United Arab Emirates
GB   United Kingdom
US   United States
UM   United States Minor Outlying Islands
UY   Uruguay
UZ   Uzbekistan
VU   Vanuatu
VE   Venezuela
VN   Vietnam
VG   Virgin Islands, British
VI   Virgin Islands, U.S.
WF   Wallis and Futuna
EH   Western Sahara
YE   Yemen
ZM   Zambia
ZW   Zimbabwe`;

export const FILE_TYPES = {
	PNG: 'image/png',
	JPG: 'image/jpg',
	HEIC: 'image/heic'
};

export const LIST_URL_NOT_REDIRECT = [
	'/funder/company/request-form',
	'/funder/individual/request-form',
	'/borrower/individual/request-form',
	'/funder/account',
	'/borrower/account',
	'/borrower/company/request-form',
	'/borrower/company',
	'/funder/company'
];

export const HONG_KONG_NATIONALITY_VALUE = 'HK';
export const CHINA_NATIONALITY_VALUE = 'CN';

export const OTHER_VALUE_TYPE = {
	OTHERS_VALUE: 'others',
	OTHER_VALUE: 'other',
	OTHER_SOURCE_OF_FUNDS: '6',
	OTHER_USE_OF_FUNDS: '4',
	OTHER_OWNERSHIP: '3'
};

export const BORROWER_CREDIT_VALUE = {
	YES: true,
	NO: false
};

export const ERROR_STATUS = 'error';

export const SESSION_EXPIRED_TIME_MS = 30 * 60 * 1000;

export const RESET_TIMEOUT_MODAL_EXPIRED_TIME_SD = 2 * 60;

export const MORTGAGE_ENV_IMPACTION_COUNTRIES = {
	JAPAN: 'JP',
	UNITED_KINGDOM: 'GB'
}

export type StepStatus = 'wait' | 'process' | 'finish' | 'error' | undefined;

export const SourceOfFundMap = new Map<string, string>();
SourceOfFundMap.set('1', 'Investment Income');
SourceOfFundMap.set('2', 'Business Income')
SourceOfFundMap.set('3', 'Salary')
SourceOfFundMap.set('4', 'Director Fee')
SourceOfFundMap.set('5', 'Dividend')
SourceOfFundMap.set('6', 'Others')
